export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(registration => {
        if (
          registration.active &&
          registration.active.scriptURL &&
          registration.active.scriptURL.includes('centivo.com')
        ) {
          registration.unregister()
        }
      })
    })
  }
}
